import PropTypes from "prop-types";
import React from 'react'
import { Helmet } from 'react-helmet-async';

// This component is kept for backward compatibility
// The actual SEO is now handled by SEOLoader component
// But for blog posts, we use metaTitle and metaDescription from the blog data
const SEO = ({ title, metaTitle, metaDescription }) => {
    // Use metaTitle if provided, otherwise fall back to title
    const finalTitle = metaTitle || title;
    
    return (
        <Helmet>
            <meta charSet="utf-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
            {/* Title will be overridden by SEOLoader if SEO data exists, but blog posts use their own meta */}
            {finalTitle && <title>{finalTitle}</title>}
            {metaDescription && <meta name="description" content={metaDescription} />}
        </Helmet>
    )
}
SEO.propTypes = {
    title: PropTypes.string,
    metaTitle: PropTypes.string,
    metaDescription: PropTypes.string
};

export default SEO;


